// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"74f3d6fa","157":"14798030","847":"14798030"}[chunkId] + ".chunk.css";
};